import { AdiFieldPreset } from '@wix/forms-common'
import { GeneralDatePicker } from '../../general-fields/definitions/general-date-picker'

export class AdiDate extends GeneralDatePicker {
  public get fieldType() {
    return AdiFieldPreset.ADI_DATE
  }

  public get mainCrmTypes() {
    return []
  }

  protected get data() {
    return {
      placeholder: this.translate(`adi.fieldTypes.${this.base.metadata.fieldType}.placeholder`),
      label: this.translate(`adi.fieldTypes.${this.base.metadata.fieldType}.label`),
    }
  }

  protected get ADI_titleTranslationKey() {
    return `adi.${this.base.metadata.fieldType}FieldEditPanel.title`
  }

  protected get crmLabel() {
    return this.translate(`fieldTypes.${this.base.metadata.fieldType}`)
  }
}
